import { isNumber } from 'lodash';
import { v4 as uuid } from 'uuid';
import { REFERENCE_LINE_DIRECTION } from './constants';
import type { ReferenceLine } from './types';

export const genReferenceLineId = () => {
    return 'ref_line_' + uuid();
};

export const getDefaultReferenceLine = (line?: Partial<ReferenceLine>): ReferenceLine => {
    return {
        id: line?.id || genReferenceLineId(),
        direction: line?.direction || REFERENCE_LINE_DIRECTION.HORIZONTAL,
        position: isNumber(line?.position) ? Math.round(line.position) : 0,
    };
};
